import React, { useState, useEffect } from "react";
import AuthLayout from "./AuthLayout";

import MainButton from "../../shared/Button";
import borderBack from "../../../assets/images/borderBack.png";
import { useNavigate, useLocation } from "react-router-dom";
import { Container } from "@mui/material";
import OtpInput from "react-otp-input";
import FormMainLayouts from "../../layouts/FormMainLayouts";
import { OTP_VERIFICATION, RESEND_OTP } from "../../../constants/apiEndPoints";
import httpRequest from "../../../axios/index";
import { toast } from "react-hot-toast";
import {
  Header,
  Linked,
  Maincontant,
  ResendMain,
  VerificationMain,
  TimeCounter,
} from "./styles/VerificationStyle";
import { useDispatch } from "react-redux";
import { loginSuccess, setRedirTo } from "../../../redux/slice/user/UserSlice";
// import { ClassSharp } from "@mui/icons-material";

const SignupVerification = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [otp, setOTP] = useState("");
  const [time, setTime] = useState("01:00");
  const [isCounting, setIsCounting] = useState(true);
  const [Loading, setLoading] = useState(false);

  const location = useLocation();
  const emailParamMatch = location.search.match(/email=([^&]+)/);
  const email = emailParamMatch ? emailParamMatch[1] : null;
  const phoneParamMatch = location.search.match(/phone=([^&]+)/);
  const phone = phoneParamMatch ? phoneParamMatch[1] : null;

  useEffect(() => {
    let countdownInterval;

    if (isCounting) {
      const [minutes, seconds] = time.split(":").map(Number);
      let totalSeconds = minutes * 60 + seconds;

      countdownInterval = setInterval(() => {
        totalSeconds--;

        const newMinutes = Math.floor(totalSeconds / 60);
        const newSeconds = totalSeconds % 60;
        const newTime = `${String(newMinutes).padStart(2, "0")}:${String(
          newSeconds
        ).padStart(2, "0")}`;
        setTime(newTime);

        if (totalSeconds === 0) {
          setIsCounting(false);
          clearInterval(countdownInterval);
        }
      }, 1000);
    }
    return () => {
      clearInterval(countdownInterval);
    };
  }, [isCounting, time]);

  const handleResendClick = async () => {
    // RESEND_OTP
    setTime("01:00");
    setIsCounting(true);
    try {
      const userObj = email ? { email } : { phone_number: phone };

      const resp = await httpRequest.post(RESEND_OTP, {
        user: userObj,
      });

      if (resp?.status === 200) {
        toast.success("An email sent to you for verification.");
        // setIsCounting(false);
        // setTime("01:00");
      }
    } catch (error) {
      const errorMessage = (
        error?.response?.data?.message || "Something went wrong"
      ).replace("Validation failed: ", "");
      toast.error(errorMessage);
    }
  };

  const handleOTPChange = (otp) => {
    setOTP(otp);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!otp) {
      toast.error("OTP is Required.");
      return;
    }

    const userObj = email ? { email, otp } : { phone_number: phone, otp };

    try {
      setLoading(true);
      const resp = await httpRequest.post(OTP_VERIFICATION, {
        user: userObj,
      });

      if (resp?.status === 200) {
        const { user } = resp?.data;

        if (resp?.data?.user?.reset_password_token) {
          navigate(
            `/change-password?token=${resp?.data?.user?.reset_password_token}`
          );
        } else {
          dispatch(loginSuccess(user));
          setTimeout(() => {
            navigate("/customer-type");
          }, 100);
          dispatch(setRedirTo("/customer-type"));
          toast.success("Successfully verified");
          setOTP("");
        }
      }
    } catch (error) {
      const errorMessage = (
        error?.response?.data?.message || "Something went wrong"
      ).replace("Validation failed: ", "");
      toast.error(errorMessage);
      setOTP("");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Container maxWidth="lg">
        <AuthLayout arrow={true}>
          <Header>
            <Linked to={-1}>
              <img src={borderBack} alt="Linkarrow" />
            </Linked>
            <Maincontant>
              <h6>Verification Code </h6>
              <p>
                We have sent the verification code to your
                {email !== undefined && email !== null ? " email" : " number"}
                <span>
                  {email !== undefined && email !== null ? email : phone}
                </span>
              </p>
            </Maincontant>
          </Header>
          <FormMainLayouts>
            <VerificationMain>
              <OtpInput
                value={otp}
                onChange={handleOTPChange}
                numInputs={4}
                renderInput={(props) => <input {...props} />}
              />
            </VerificationMain>
            <TimeCounter>{time}</TimeCounter>
            <ResendMain>
              <span>Didn’t receive the code? </span>
              <button onClick={handleResendClick} disabled={isCounting}>
                Resend
              </button>
            </ResendMain>
            <MainButton
              type="submit"
              label="Submit"
              MT="20"
              onClick={handleSubmit}
              isLoading={Loading}
            />
          </FormMainLayouts>
        </AuthLayout>
      </Container>
    </>
  );
};

export default SignupVerification;
